import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import CardCategoryBox1 from "components/CardCategoryBox1/CardCategoryBox1";
import Heading from "components/Heading/Heading";
import { TaxonomyType } from "data/types";
import { API_BASE_URL } from "data/axiosClient";

export interface SectionGridCategoryBoxProps {
  headingCenter?: boolean;
  categoryCardType?: "card1";
  className?: string;
  gridClassName?: string;
}

const SectionGridCategoryBox: React.FC<SectionGridCategoryBoxProps> = ({
  headingCenter = true,
  categoryCardType = "card1",
  className = "",
  gridClassName = "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
}) => {
  const [categories, setCategories] = useState<TaxonomyType[]>([]);
  const [categoryName, setCategoryName] = useState<string>("");
  const [categoryDescription, setCategoryDescription] = useState<string>("");
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get("cat-id");

  useEffect(() => {
    const fetchCategories = async () => {
      if (!categoryId) {
        console.error("Category ID is missing from the URL");
        return;
      }

      try {
        const response = await fetch(`${API_BASE_URL}/products/categories/${categoryId}/subcategories/`);
        const data = await response.json();

        if (response.ok) {
          const mappedCategories = data.data.map((item: any) => ({
            id: item.id.toString(),
            href: `/products/${item.id}`,
            name: item.name,
            taxonomy: `category_${item.id}`,
            count: item.product_count,
            thumbnail: item.image_url,
            description: item.description,  
          }));
          setCategories(mappedCategories);
          setCategoryName(data.category_name); // Set category name
          setCategoryDescription(data.category_description); // Set category description
        } else {
          console.error("Failed to fetch categories", data.message);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, [categoryId]);

  let CardComponentName = CardCategoryBox1;
  switch (categoryCardType) {
    case "card1":
      CardComponentName = CardCategoryBox1;
      break;

    default:
      CardComponentName = CardCategoryBox1;
  }

  return (
    <div className={`nc-SectionGridCategoryBox relative ${className}`}>
      <Heading
        desc={categoryDescription || "Discover great places near where you live"}
        isCenter={headingCenter}
      >
        {categoryName || "Explore nearby"}
      </Heading>
      <div className={`grid ${gridClassName} gap-5 sm:gap-6 md:gap-8`}>
        {categories.length > 0 ? (
          categories.map((item, i) => (
            <CardComponentName key={i} taxonomy={item} />
          ))
        ) : (
          <div>No products available</div>
        )}
      </div>
    </div>
  );
};

export default SectionGridCategoryBox;
